"use strict";

define('libs/format/link',['require','exports','module','underscore','handlebars','../route.helper'],function (require, exports, module) {
  var _ = require('underscore');
  var Handlebars = require('handlebars');
  var RouteHelper = require('../route.helper');
  var linkFormatter = function linkFormatter(routeName, mapping, additionalAttrs) {
    var generateAttributesString = function generateAttributesString(additionalAttrs) {
      var attrString = '';
      if (additionalAttrs) {
        for (var attr in additionalAttrs) {
          attrString += String(attr) + '="' + additionalAttrs[attr] + '" ';
        }
      }
      return attrString;
    };
    return function (value, model) {
      this.routeHelper = new RouteHelper(routeName).add(model, mapping);
      var attributesString = generateAttributesString(additionalAttrs);
      return new Handlebars.SafeString('<a ' + attributesString + 'href="' + this.routeHelper.get('link') + '">' + Handlebars.escapeExpression(value) + '</a>');
    };
  };
  module.exports = linkFormatter;
});

